import { render, staticRenderFns } from "./img-gif.vue?vue&type=template&id=2ac2dccb&scoped=true"
import script from "./img-gif.vue?vue&type=script&lang=js"
export * from "./img-gif.vue?vue&type=script&lang=js"
import style0 from "./img-gif.vue?vue&type=style&index=0&id=2ac2dccb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2dccb",
  null
  
)

export default component.exports